// extracted by mini-css-extract-plugin
module.exports = {"submit--position":"ResendConfirmation_submit--position__3KwpH"};